let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8nE8V")).then(() => parcelRequire('jdbMO'));